module.exports = __webpack_public_path__ + "static/media/sber-green.d70177f4.png";